module.exports = __webpack_public_path__ + "media/images/admin/icons/type-c8ca5bc852f06d8c09f8f0243627eeee.svg";